
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 128 128"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7 11.4v105.3h114V11.4H7zm75.4 89.7H21.3l27.3-37.3-27.3-34.1h61.1L113 63.8l-30.6 37.3z"}}),_c('path',{attrs:{"opacity":".7","d":"M21.3 101.1h61.1L113 63.8H48.7z"}})])
          )
        }
      }
    